import React, {Fragment, useState} from 'react';
import Notification from './Notification';
import {useInfiniteQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {
    fetchUserNotifications, markUserAllNotificationOpen,
    markUserNotificationOpen, USER_CURRENT_KEY,
    USER_NOTIFICATIONS_KEY, USER_UNREAD_NOTIFICATIONS_KEY
} from "../../../api/public-voissa/users";
import './NotificationList.scss';
import _ from "lodash";
import Button from '../UI/Button/Button';
import Group from "../UI/Group/Group";
import createLink from "../../../libs/createLink";
//import useCurrentUser from '../../../hooks/useCurrentUser';
import ContentLocked from '../ContentLocked/ContentLocked';
import CONTENT_RESTRICTION_RULE from '../../../const/contentRestrictionRule';
import NoContent from '../NoContent/NoContent';
import useRestriction from '../../../hooks/useRestriction';
import useFilters from '../../../hooks/useFilters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsFilter, faGear } from '@fortawesome/pro-solid-svg-icons';
import Drawer from '../Drawer/Drawer';
import MenuList, { MenuListGroup, MenuListItem } from '../MenuList/MenuList';


const filters = {
    currentType: {
        multiple: false,
        uriParam: "currentType",
        label: "Type de notification",
        defaultValue: "",
        options: [
            {
                label: "Tout",
                uriParam: "all",
                value: ""
            },
            {
                label: "Likes",
                uriParam: "likes",
                value: "likes"
            },
            {
                label: "Commentaires",
                uriParam: "comments",
                value: "comments"
            },
            /*{
                label: "Mentions",
                uriParam: "mentions",
                value: "mentions"
            },*/
            {
                label: "Social",
                uriParam: "social",
                value: "social"
            },
            {
                label: "Vues de profil",
                uriParam: "viewProfile",
                value: "viewProfile"
            },
            /*{
                label: "Statuts",
                uriParam: "status",
                value: "status"
            },*/
            {
                label: "Threads",
                uriParam: "threads",
                value: "threads"
            },
            {
                label: "Systèmes",
                uriParam: "system",
                value: "system"
            }
        ]
    },
};


const NotificationsList = ({
        isPage = false,
        ...props
    }) =>{
    const explorerFilter = useFilters(filters, 'notifications');
    const [toogleFilters, setToogleFilters] = useState(false);
    //const currentUserSub = useCurrentUser();
    const restriction = useRestriction(CONTENT_RESTRICTION_RULE.USER_NOTIFICATIONS_LIMIT);
    let filter = {
        limit: restriction.isRestricted ? restriction?.restrictionParams?.limit : 20,
        lastId: null,
        ...explorerFilter.apiFilter
    };

    const queryClient = useQueryClient();
    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);

    const {
        mutate : mutateOpenAllNotification,
        isLoading : isLoadingOpenAllNotification
    } = useMutation(() => markUserAllNotificationOpen(),{
        onSuccess: async () =>{
            //await queryClient.invalidateQueries([USER_UNREAD_NOTIFICATIONS_KEY]);
            await queryClient.invalidateQueries([USER_NOTIFICATIONS_KEY]);
        }
    });

    const {isSuccess : isSuccessNotifications, isFetchingNextPage : isFetchedNotifications, data : dataNotifications, fetchNextPage : fetchNextPageNotifications, hasNextPage : hasNextPageNotifications} = useInfiniteQuery(
        [USER_NOTIFICATIONS_KEY, filter],
        ({pageParam = null}) => fetchUserNotifications({...filter, lastId : pageParam}),
        {
            staleTime : false,
            onSuccess : async () =>{
                await queryClient.invalidateQueries([USER_UNREAD_NOTIFICATIONS_KEY]);
            },
            getNextPageParam: (lastPage, pages) => {
                if(restriction.isRestricted) return null;
                return lastPage && lastPage.more ? lastPage.lastId : null
            }
        }
    );

    const {
        mutate : mutateReadNotification,
    } = useMutation(notificationId => markUserNotificationOpen(notificationId),{
        onSuccess: (data) =>{

            const queryCache = queryClient.getQueryCache()
            const queryKeys = queryCache.getAll().map(cache => cache.queryKey).filter(cache => cache[0] === USER_NOTIFICATIONS_KEY);

            queryKeys.forEach(queryKey =>{
                const previousValue = queryClient.getQueryData(queryKey);
                if(previousValue){
                    const newPagesArray = previousValue?.pages.map((page) => {
                            page.data = page.data.map((item) => {
                                if(item._id.toString() === data._id.toString()){
                                    item = {...item, open : true};
                                }
                                return item;
                            });
                            return page;
                        }
                    ) ?? []

                    queryClient.setQueryData(queryKey, oldData => ({
                        pages: newPagesArray,
                        pageParams: oldData.pageParams,
                    }));
                }
            });

        }
    });

    let totalNotification = _.get(dataNotifications,'pages[0].total') || 0;
    const activeFilterCount = Object.keys(explorerFilter.apiFilter).length;
    return (
        <div className="notifications-list" {...props}>
            <Group split style={{marginBottom : "10px"}}>
                <Group>
                    <Button onClick={() => mutateOpenAllNotification()} loading={isLoadingOpenAllNotification}>Tout marquer lu</Button>
                    <Button onlyIcon onClick={()=>setToogleFilters(!toogleFilters)} active={toogleFilters} badge={!!activeFilterCount && activeFilterCount}>
                        <FontAwesomeIcon icon={faBarsFilter}/>
                    </Button>
                </Group>
                <Button onlyIcon isLink to={createLink("userMeSettingsOptionsNotifications", currentUser)}><FontAwesomeIcon icon={faGear}/></Button>
            </Group>
            
            {isFetchedNotifications && "Chargement des notifications"}
            {totalNotification === 0 ? (
                    <NoContent>Aucune notification pour le moment</NoContent>
                    // <div className="no-content">Aucune notification pour le moment</div>
                ) :
                isSuccessNotifications && dataNotifications.pages.map((group, i) => (
                    <Fragment key={i}>
                        {group.data.map((notification, index) => (
                            <Notification
                                key={index}
                                data={notification}
                                onOpen={() => {
                                    if (!notification.open) mutateReadNotification(notification._id);
                                }}/>
                        ))}
                    </Fragment>
                ))
            }
            {restriction.isRestricted && <ContentLocked restrictionRule={CONTENT_RESTRICTION_RULE.USER_NOTIFICATIONS_LIMIT} style={{marginTop:'8px'}}/>}
            {(isPage && hasNextPageNotifications && !restriction.isRestricted) && <div className="see-more-notifications">
                <Button loading={isFetchedNotifications} onClick={() => fetchNextPageNotifications()}>Afficher plus de notifications</Button>
            </div>}
            {(!isPage && !restriction.isRestricted) && (
                <div className="see-all-notifications" style={{padding:"8px", marginTop:'8px'}}>
                <Button isLink to="/notifications">Voir toutes</Button>
            </div>)}

            <Drawer
                small
                open={toogleFilters}
                handleClose={()=>setToogleFilters(false)}
                headContent="Filtrer les notifications"
            >
                <MenuList style={{padding:'10px'}}>
                    <MenuListGroup label={filters.currentType.label}>
                        {filters.currentType.options.map((option, optionIndexe) => (
                            <MenuListItem key={optionIndexe} onClick={()=> explorerFilter.setValue('currentType', option.value)} active={explorerFilter.getValue('currentType') === option.value}>{option.label}</MenuListItem>
                        ))}
                    </MenuListGroup>
                </MenuList>
            </Drawer>
        </div>
    )
};

export default NotificationsList;